/* global angular */

( function () {
	'use strict';

	function pdStatusReportPdf ( moment, pdfCommonFactory, pdStatusFactory ) {
		function getPdStatus ( pdList ) {
			var status = 'Incomplete';

			if ( pdList.completedDate ) {
				status = 'Complete';
			}

			return status;
		}

		function mapAllPds ( pd ) {
			var showDescription = this.showDescription;
			var pdTitleArr      = [ pd.contentName, pd.contentName, pd.contentName, 'Digital Signature' ];
			var offset          = parseInt( pd.type, 10 ) - 1;

			var description = { 'columns' : [ {
				'text'  : 'Description',
				'style' : 'frontPageHeaderKey', 'width' : '25%'
			}, {
				'text'  : pd.contentDescription,
				'style' : 'frontPageHeaderValue',
				'width' : '75%'
			} ] };

			var userPdItemList = [ {
				'columns' : [ {
					'text'  : 'Observation Title',
					'style' : 'frontPageHeaderKey',
					'width' : '25%'
				}, {
					'text'  : pd.observation.name,
					'style' : 'frontPageHeaderValue',
					'width' : '75%'
				} ]
			}, {
				'columns' : [ {
					'text'  : 'Observation Date',
					'style' : 'frontPageHeaderKey',
					'width' : '25%'
				}, {
					'text'  : pd.observation.startDate,
					'style' : 'frontPageHeaderValue',
					'width' : '75%'
				} ]
			}, {
				'columns' : [ {
					'text'  : 'Title',
					'style' : 'frontPageHeaderKey',
					'width' : '25%'
				}, {
					'text'  : pdTitleArr[ offset ] || '',
					'style' : 'frontPageHeaderValue',
					'width' : '75%'
				} ]
			}, {
				'columns' : [ {
					'text'  : 'Template',
					'style' : 'frontPageHeaderKey',
					'width' : '25%'
				}, {
					'text'  : pd.observation.template.name,
					'style' : 'frontPageHeaderValue',
					'width' : '75%'
				} ]
			}, {
				'columns' : [ {
					'text'  : 'Observer',
					'style' : 'frontPageHeaderKey',
					'width' : '25%'
				}, {
					'text'  : pd.observation.observer,
					'style' : 'frontPageHeaderValue',
					'width' : '75%'
				} ]
			}, {
				'columns' : [ {
					'text'  : 'Due Date',
					'style' : 'frontPageHeaderKey',
					'width' : '25%'
				}, {
					'text'  : pd.dueDate || '--/--/--',
					'style' : 'frontPageHeaderValue',
					'width' : '75%'
				} ]
			}, {
				'columns' : [ {
					'text'  : 'Status',
					'style' : 'frontPageHeaderKey',
					'width' : '25%'
				}, {
					'text'  : getPdStatus( pd ),
					'style' : 'frontPageHeaderValue',
					'width' : '75%'
				} ]
			}, {
				'text' : '\n\n'
			} ];

			if ( showDescription ) {
				userPdItemList.splice( 3, 0, description );
			}

			return {
				'stack' : userPdItemList
			};
		}

		function mapUserInfo ( user ) {
			var showDescription = this.showDescription;

			var header = {
				'columns' : [ {
					'text'  : 'School : ',
					'style' : 'pdStatusUserReportHeader',
					'width' : '10%'
				}, {
					'text'  : user.school,
					'style' : 'pdStatusUserReportHeader'
				}, {
					'text'  : 'Invitee : ',
					'style' : 'pdStatusUserReportHeader',
					'width' : '10%'
				}, {
					'text'  : user.observee,
					'style' : 'pdStatusUserReportHeader'
				}, {
					'text'  : user.status,
					'style' : 'pdStatusUserReportHeaderProgress'
				} ],

				'margin' : [ 0, 0, 0, -18 ]
			};

			var userPdStats = {
				'stack' : [ header, pdfCommonFactory.horizontalRule( 1 ) ]
			};

			var allPd      = user.data.all;
			var userPdList = allPd.map( mapAllPds.bind( { 'showDescription' : showDescription } ) );

			userPdStats.stack.push( { 'stack' : userPdList } );

			return userPdStats;
		}

		function buildPdStatusReport ( list, showDescription ) {
			var pdStatusReport = list.map( mapUserInfo.bind( { 'showDescription' : showDescription } ) );

			return {
				'stack' : [].concat.apply( [], pdStatusReport )
			};
		}

		function generateFrontPageDetails ( filters ) {
			var section = {
				'stack' : [
					{
						'columns' : [
							{
								'text'      : 'Search Criteria',
								'width'     : '25%',
								'alignment' : 'right'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Template(s)',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : filters.templates,
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Invitee(s)',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : filters.invitees,
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Date Range From',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : moment( filters.dateRange.startDate ).format( 'MM/DD/YY' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Date Range To',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : moment( filters.dateRange.endDate ).format( 'MM/DD/YY' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Location(s)',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : filters.locations,
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Report Generated On',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : moment( new Date() ).format( 'MM/DD/YY h:mm A' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}
				]
			};

			return section;
		}

		function generateFrontPage ( filters ) {
			var sections = {
				'stack' : [ pdfCommonFactory.createHeader( filters.templateTitle ),
					pdfCommonFactory.horizontalRule( 2 ),
					generateFrontPageDetails( filters ) ]
			};

			return sections;
		}

		function buildReport ( showDescription, pdList, filters ) {
			var groupedData = pdStatusFactory.groupPds( pdList );

			var sections = {
				'stack' : [
					pdfCommonFactory.createHeader( filters.templateTitle ),
					pdfCommonFactory.horizontalRule( 2 ),
					buildPdStatusReport( groupedData, showDescription )
				],

				'pageBreak' : 'before'
			};

			return sections;
		}

		return {
			'buildReport'       : buildReport,
			'generateFrontPage' : generateFrontPage
		};
	}

	angular
		.module( 'app.components' )
		.factory( 'pdStatusReportPdf', pdStatusReportPdf );

	pdStatusReportPdf.$inject = [ 'moment', 'pdfCommonFactory', 'pdStatusFactory' ];
} )( );
